import { Constructor } from "core/features/components/types/constructor";
import { EventArg } from "front-end/types/event-arg";
import { Observable, Subject } from "rxjs";

export interface IEventEmitter {
    on(event: string): Observable<EventArg>;
    emit(event: string, arg?: EventArg): void;
}

export const EventEmitterMixin = <TBaseClass extends Constructor<object>> (
    BaseClass: TBaseClass
): TBaseClass & Constructor<IEventEmitter> => {

    return class EventEmitterExtension extends BaseClass implements IEventEmitter {
        protected _subjects: Map<string, Subject<EventArg>> = new Map<string, Subject<EventArg>>();

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        public constructor(...args: Array<any>) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            super(...args);
        }

        public on(event: string): Observable<EventArg> {
            if (!this._subjects.has(event)) {
                this._subjects.set(event, new Subject<EventArg>());
            }

            return this._subjects.get(event).asObservable();
        }

        public emit(event: string, arg?: EventArg): void {
            const subject = this.getSubject(event);

            subject.next(arg);
        }

        public complete(event: string): void {
            const subject = this.getSubject(event);
            subject.complete();

            this._subjects.delete(event);
        }

        private getSubject(event: string): Subject<EventArg> {
            const subject = this._subjects.get(event);

            if(!subject) {
                throw new Error(`Unknown subject ${event}`);
            }

            return subject;
        }
    };
};
